import pmrc from "../../assets/images/club_images/pmrc.png";
import PMRC from "../../assets/images/banner/pmrc.jpeg";

import ECELL from "../../assets/images/banner/ecell.jpeg";
import ecell from "../../assets/images/club_images/ecell.png";

import TC from "../../assets/images/banner/technocracy.jpeg";
import tc from "../../assets/images/club_images/technocracy.png";

import nrityam from "../../assets/images/club_images/nrityam.png";
import NRITYAM from "../../assets/images/banner/nrityam.jpeg";

import click from "../../assets/images/club_images/click.png";
import CLICK from "../../assets/images/banner/click.jpeg";

import robo from "../../assets/images/club_images/robo.png";
import ROBO from "../../assets/images/banner/robotix.jpeg";

import gg from "../../assets/images/club_images/gogreen.png";
import GG from "../../assets/images/banner/green.jpeg";

import abhinay from "../../assets/images/club_images/abhinay.png";
import ABHINAY from "../../assets/images/banner/abhinay.jpeg";

import raaga from "../../assets/images/club_images/raaga.png";
import RAAGA from "../../assets/images/banner/raaga.jpeg";

import fcc from "../../assets/images/club_images/fcc.png";
import FCC from "../../assets/images/banner/fcc.jpeg";

import nss from "../../assets/images/club_images/nss.png";
import NSS from "../../assets/images/banner/nss.jpeg";

import literati from "../../assets/images/club_images/lierati.png";
import LITERATI from "../../assets/images/banner/literati.jpeg";

import icell from "../../assets/images/club_images/icell.png";
import ICELL from "../../assets/images/banner/innovation.jpeg";

import sanskriti from "../../assets/images/club_images/sanskriti.png";
import SANSKRITI from "../../assets/images/banner/sanskriti.jpeg";

import tedx from "../../assets/images/club_images/tedx.png";
import TEDX from "../../assets/images/banner/tedx.jpeg";

import shaurya from "../../assets/images/club_images/shaurya.png";
import SHAURYA from "../../assets/images/banner/shaurya.jpeg";

import tcp from "../../assets/images/club_images/tcp.png";
import TCP from "../../assets/images/banner/tcp.jpeg";

import sahyog from "../../assets/images/club_images/sahyog.png";
import SAHYOG from "../../assets/images/banner/sahyog.jpeg";

export const cardData = [
  {
    id: 1,
    svg: pmrc,
    name: "PMRC",
    banner: PMRC,
    desc: "PMRC is the student media body of NIT Raipur which comprises of a group dedicated coordinators who cover all the events happening around the institute by writing press releases, taking photographs, designing posters and ensuring that each and every event of the Institute gets its due media coverage.",
    socialLinks: {
      instagram: "https://instagram.com/",
      twitter: "https://twitter.com/",
      linkedin: "https://linkedin.com/in/",
      whatsapp: "https://api.whatsapp.com/send?phone=YOUR_PHONE_NUMBER",
    },
  },
  {
    id: 2,
    svg: ecell,
    name: "Entrepreneurship Cell",
    banner: ECELL,
    desc: "The Entrepreneurship cell, NIT Raipur is a non-profit organization that advocates to inculcate entrepreneurial spirit among the budding young minds who have the ardour to pursue entrepreneurship and aggrandize the ideas that have the potential to excel.",
    socialLinks: {
      instagram: "https://instagram.com/",
      twitter: "https://twitter.com/",
      linkedin: "https://linkedin.com/in/",
      whatsapp: "https://api.whatsapp.com/send?phone=YOUR_PHONE_NUMBER",
    },
  },
  {
    id: 3,
    svg: tc,
    name: "Team Technocracy",
    banner: TC,
    desc: "The Students Technical Committee, organizes technical workshops, seminars and events throughout the year. Also, this committee organizes annual techfest of the Institute, AAVARTAN. During Aavartan, Vigyaan a national level science exhibition is the center of attraction along with mega events in different domains like coding, robotics etc.",
    socialLinks: {
      instagram: "https://instagram.com/",
      twitter: "https://twitter.com/",
      linkedin: "https://linkedin.com/in/",
      whatsapp: "https://api.whatsapp.com/send?phone=YOUR_PHONE_NUMBER",
    },
  },
  {
    id: 4,
    svg: nrityam,
    name: "Nrityam",
    banner: NRITYAM,
    desc: "Nrityam works with the objective of promoting dance as an art at different platforms. It considers dance important, as it not only instills confidence and improves the personality of an individual but also helps our cultural heritage to sustain and adopt change.",
    socialLinks: {
      instagram: "https://instagram.com/",
      twitter: "https://twitter.com/",
      linkedin: "https://linkedin.com/in/",
      whatsapp: "https://api.whatsapp.com/send?phone=YOUR_PHONE_NUMBER",
    },
  },
  {
    id: 5,
    svg: tcp,
    name: "Turing Club of Programmers",
    banner: TCP,
    desc: "TCP aims to foster and nurture invigorating coding culure among the sudents of the Institute through its Mentorship programme, workshops, and along with several other events including the annual event CodeUtsava.",
    socialLinks: {
      instagram: "https://instagram.com/",
      twitter: "https://twitter.com/",
      linkedin: "https://linkedin.com/in/",
      whatsapp: "https://api.whatsapp.com/send?phone=YOUR_PHONE_NUMBER",
    },
  },
  {
    id: 6,
    svg: click,
    name: "Click Club",
    banner: CLICK,
    desc: "Click Club is a hub for photographic enthusiast in NIT Raipur. It aims to showcase one's talent and learn from each experience in a collaborative way. It handles all the the official coverage charge of events.",
    socialLinks: {
      instagram: "https://instagram.com/",
      twitter: "https://twitter.com/",
      linkedin: "https://linkedin.com/in/",
      whatsapp: "https://api.whatsapp.com/send?phone=YOUR_PHONE_NUMBER",
    },
  },
  {
    id: 7,
    svg: sahyog,
    name: "Sahyog",
    banner: SAHYOG,
    desc: "The primary objective of this team is to provide guidance to junior students by senior students through positive and constructive interactions. It works as a link between students and counseling cell of the Institute which facilitates students to seek solutions to their problems.",
    socialLinks: {
      instagram: "https://instagram.com/",
      twitter: "https://twitter.com/",
      linkedin: "https://linkedin.com/in/",
      whatsapp: "https://api.whatsapp.com/send?phone=YOUR_PHONE_NUMBER",
    },
  },
  {
    id: 8,
    svg: raaga,
    name: "Raaga",
    banner: RAAGA,
    desc: "The music club of Institute Raaga was founded in year 2010 and since then, it has witnessed enthusiastic participation from the students. An annual musical evening, Shruti is organized by the group.",
    socialLinks: {
      instagram: "https://instagram.com/",
      twitter: "https://twitter.com/",
      linkedin: "https://linkedin.com/in/",
      whatsapp: "https://api.whatsapp.com/send?phone=YOUR_PHONE_NUMBER",
    },
  },
  {
    id: 9,
    svg: icell,
    name: "Innovation Cell",
    banner: ICELL,
    desc: "Innovation cell aims to inculcate the spirit of innovation and entrepreneurship amongst the students, encourage and support innovations through guidance, mentorship and support. Students will be encouraged to take up innovative projects with possibility of commercialization.",
    socialLinks: {
      instagram: "https://instagram.com/",
      twitter: "https://twitter.com/",
      linkedin: "https://linkedin.com/in/",
      whatsapp: "https://api.whatsapp.com/send?phone=YOUR_PHONE_NUMBER",
    },
  },
  {
    id: 10,
    svg: fcc,
    name: "Finance Club",
    banner: FCC,
    desc: "The central focus of the Finance club is to cultivate interest among the students towards the financial sector as well as to promote it as a viable career option post their engineering degree. Finance club will provide students an opportunity to explore the world of Finance, Business Consulting and Analytics.",
    socialLinks: {
      instagram: "https://instagram.com/",
      twitter: "https://twitter.com/",
      linkedin: "https://linkedin.com/in/",
      whatsapp: "https://api.whatsapp.com/send?phone=YOUR_PHONE_NUMBER",
    },
  },
  {
    id: 11,
    svg: nss,
    name: "NSS",
    banner: NSS,
    desc: "National Service Scheme was founded in 1969 with the aim of providing the youths of the country with hands-on experience of community service. We, at NIT Raipur aim to do the same. Team NSS of NIT Raipur is committed to organizing events that help to promote social awareness and give something back to the society. ",
    socialLinks: {
      instagram: "https://instagram.com/",
      twitter: "https://twitter.com/",
      linkedin: "https://linkedin.com/in/",
      whatsapp: "https://api.whatsapp.com/send?phone=YOUR_PHONE_NUMBER",
    },
  },
  {
    id: 12,
    svg: literati,
    name: "Literati",
    banner: LITERATI,
    desc: "Literati's main objective is to enhance the literary skills of students, to bring to light the hidden talents among the students and conduct various literary events providing a platform for the students to come up with their not so known skills. ",
    socialLinks: {
      instagram: "https://instagram.com/",
      twitter: "https://twitter.com/",
      linkedin: "https://linkedin.com/in/",
      whatsapp: "https://api.whatsapp.com/send?phone=YOUR_PHONE_NUMBER",
    },
  },
  {
    id: 13,
    svg: gg,
    name: "Go Green",
    banner: GG,
    desc: "The green movement of this institution was founded in the year 2010 with the purpose of educating the students about the environmental perils which await us and also empowering the students to contribute towards a greener environment by providing them with the appropriate opportunities.",
    socialLinks: {
      instagram: "https://instagram.com/",
      twitter: "https://twitter.com/",
      linkedin: "https://linkedin.com/in/",
      whatsapp: "https://api.whatsapp.com/send?phone=YOUR_PHONE_NUMBER",
    },
  },
  {
    id: 14,
    svg: robo,
    name: "Robotix",
    banner: ROBO,
    desc: "ROBOTiX Club is the Robotics outreach of NIT Raipur. The was founded in the year 2014 with the purpose of technological skills in the diverse fields of mechatronics robotics by transcending the theoretical knowledge into applications to provide modelled solutions for realproblems.",
    socialLinks: {
      instagram: "https://instagram.com/",
      twitter: "https://twitter.com/",
      linkedin: "https://linkedin.com/in/",
      whatsapp: "https://api.whatsapp.com/send?phone=YOUR_PHONE_NUMBER",
    },
  },
  {
    id: 15,
    svg: abhinay,
    name: "Abhinay",
    banner: ABHINAY,
    desc: "Abhinay - The Dramatics Club brings society to life through diverse performances like street plays, stage dramas, and sketches. We offer students both a platform to showcase talent and structured mentorship to hone their skills. Members gain confidence, exposure to various theatre elements, and invaluable team and personality development experiences that benefit their future endeavors.",
    socialLinks: {
      instagram: "https://instagram.com/",
      twitter: "https://twitter.com/",
      linkedin: "https://linkedin.com/in/",
      whatsapp: "https://api.whatsapp.com/send?phone=YOUR_PHONE_NUMBER",
    },
  },
  {
    id: 16,
    svg: tedx,
    name: "Team TEDx",
    banner: TEDX,
    desc: "NIT Raipur was granted the license to organise its first independent TED conference in 2017. The purpose of bringing this, world recognised conference to the institute, was to bring innovators and achievers from various walks of life to NIT Raipur via a platform as huge as TED. TEDxNITRaipur also serves as a platform for the students and local talents to showcase themselves at the global level.",
    socialLinks: {
      instagram: "https://instagram.com/",
      twitter: "https://twitter.com/",
      linkedin: "https://linkedin.com/in/",
      whatsapp: "https://api.whatsapp.com/send?phone=YOUR_PHONE_NUMBER",
    },
  },
  {
    id: 17,
    svg: shaurya,
    name: "Shaurya",
    banner: SHAURYA,
    desc: "Shaurya has been at the helm of conducting all the sports activities in the institute. the committee organizes events Samar(the annual sports fest), Inter-branch tournaments, etc. The committee also helps in proper structuring and formation of teams which represent NIT Raipur in national level sports fest including Inter-NIT Sports meet.",
    socialLinks: {
      instagram: "https://instagram.com/",
      twitter: "https://twitter.com/",
      linkedin: "https://linkedin.com/in/",
      whatsapp: "https://api.whatsapp.com/send?phone=YOUR_PHONE_NUMBER",
    },
  },
  {
    id: 18,
    svg: sanskriti,
    name: "Sanskriti",
    banner: SANSKRITI,
    desc: "Nrityam works with the objective of promoting dance as an art at different platforms. It considers dance important, as it not only instills confidence and improves the personality of an individual but also helps our cultural heritage to sustain and adopt change.",
    socialLinks: {
      instagram: "https://instagram.com/",
      twitter: "https://twitter.com/",
      linkedin: "https://linkedin.com/in/",
      whatsapp: "https://api.whatsapp.com/send?phone=YOUR_PHONE_NUMBER",
    },
  },
];

export const socialIcons = [
  {
    key: "instagram",
    containerClass: "containerOne",
    svgClass: "instagramSvg",
    viewBox: "0 0 16 16",
    pathData:
      "M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.917 3.917 0 0 0-1.417.923A3.927 3.927 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.916 3.916 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.926 3.926 0 0 0-.923-1.417A3.911 3.911 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0h.003zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599.28.28.453.546.598.92.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.47 2.47 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.478 2.478 0 0 1-.92-.598 2.48 2.48 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233 0-2.136.008-2.388.046-3.231.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92.28-.28.546-.453.92-.598.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045v.002zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92zm-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217zm0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334z",
  },
  {
    key: "twitter",
    containerClass: "containerTwo",
    svgClass: "twitterSvg",
    viewBox: "0 0 16 16",
    pathData:
      "M5.026 15c6.038 0 9.341-5.003 9.341-9.334 0-.14 0-.282-.006-.422A6.685 6.685 0 0 0 16 3.542a6.658 6.658 0 0 1-1.889.518 3.301 3.301 0 0 0 1.447-1.817 6.533 6.533 0 0 1-2.087.793A3.286 3.286 0 0 0 7.875 6.03a9.325 9.325 0 0 1-6.767-3.429 3.289 3.289 0 0 0 1.018 4.382A3.323 3.323 0 0 1 .64 6.575v.045a3.288 3.288 0 0 0 2.632 3.218 3.203 3.203 0 0 1-.865.115 3.23 3.23 0 0 1-.614-.057 3.283 3.283 0 0 0 3.067 2.277A6.588 6.588 0 0 1 .78 13.58a6.32 6.32 0 0 1-.78-.045A9.344 9.344 0 0 0 5.026 15z",
  },
  {
    key: "linkedin",
    containerClass: "containerThree",
    svgClass: "linkdinSvg",
    viewBox: "0 0 448 512",
    pathData:
      "M100.28 448H7.4V148.9h92.88zM53.79 108.1C24.09 108.1 0 83.5 0 53.8a53.79 53.79 0 0 1 107.58 0c0 29.7-24.1 54.3-53.79 54.3zM447.9 448h-92.68V302.4c0-34.7-.7-79.2-48.29-79.2-48.29 0-55.69 37.7-55.69 76.7V448h-92.78V148.9h89.08v40.8h1.3c12.4-23.5 42.69-48.3 87.88-48.3 94 0 111.28 61.9 111.28 142.3V448z",
  },
  {
    key: "whatsapp",
    containerClass: "containerFour",
    svgClass: "whatsappSvg",
    viewBox: "0 0 16 16",
    pathData:
      "M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.898 7.898 0 0 0 13.6 2.326zM7.994 14.521a6.573 6.573 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.557 6.557 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729 0 0 0-.529.247c-.182.198-.691.677-.691 1.654 0 .977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z",
  },
];
